import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { AlertController, NavController } from '@ionic/angular';
import { forkJoin } from 'rxjs';
import { User } from 'src/app/interfaces/user';
import { AuthService } from 'src/app/services/auth.service';
import { ChatroomService } from 'src/app/services/chatroom.service';

@Component({
  selector: 'app-personal-page-wrapper',
  templateUrl: './personal-page-wrapper.component.html',
  styleUrls: ['./personal-page-wrapper.component.scss'],
})
export class PersonalPageWrapperComponent implements OnInit {
  user: User;
  currentPath: string;
  isLoading: boolean;

  constructor(
    private authService: AuthService,
    private location: Location,
    private navController: NavController,
    private alertController: AlertController,
    private chatroomService: ChatroomService,
  ) {}

  ngOnInit() {
    this.getData();
  }

  getData() {
    this.isLoading = true;
    this.currentPath = this.location.path();

    const userReq = this.authService.getProfile();

    forkJoin([userReq]).subscribe({
      next: ([userRes]) => {
        this.user = userRes.user;
      },
      complete() {
        this.isLoading = false;
      },
    });
  }

  isMenuActive(path: string) {
    return this.currentPath.includes(path);
  }

  navigateTo(path: string) {
    this.navController.navigateForward(path, {
      animated: false,
    });
  }

  navigateToChatroom() {
    this.chatroomService.goToChatroomPage(this.user.username, this.user.email);
  }

  transformtoHumanReadablePoint(point: number): string {
    let humanReadablePoint = '';

    if (point < 1000) {
      return point.toString();
    }

    if (point < 1_000_000) {
      humanReadablePoint = Math.floor(point / 1000) + 'rb+';
      return humanReadablePoint;
    }

    if (point < 1_000_000_000) {
      humanReadablePoint = Math.floor(point / 1_000_000) + 'Jt+';
      return humanReadablePoint;
    }

    humanReadablePoint = Math.floor(point / 1_000_000_000) + 'M+';
    return humanReadablePoint;
  }

  async onLogout() {
    const alert = await this.alertController.create({
      mode: 'ios',
      header: 'Konfirmasi keluar',
      message: 'Yakin ingin keluar?',
      buttons: [
        {
          text: 'Keluar',
          handler: () => {
            this.authService.logout();
            this.navController.navigateRoot('/login');
          },
        },
        {
          text: 'Batal',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
            console.log('Confirm Cancel');
          },
        },
      ],
    });
    return await alert.present();
  }
}
